module.exports = __webpack_public_path__ + "img/bg_video.73f93f52.jpg";